import { rtkApi } from '@/shared/api';
import { SuccessApiResponse } from '@/shared/types/common';
import { IAttendanceResponse } from './types';

const attendanceApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    getAttendance: build.query<IAttendanceResponse, void>({
      query: () => '/student/my-profile/attendance',
      transformResponse: (response: SuccessApiResponse<IAttendanceResponse>) => response.data,
    }),
  }),
});

export const { useGetAttendanceQuery } = attendanceApi;
